/**
 * One letter per affix word, joined without spaces: "van der" → "vd", "de" → "d".
 * Words starting with an apostrophe ("'t", "'s") have no single letter to keep and stay whole.
 */
export function abbreviateAffix(affix: string): string {
  return affix
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(word => (word.startsWith("'") ? word : word.charAt(0)))
    .join('');
}
